// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3bjn6","cards":"Cards_cards__314Rx","card":"Cards_card__eGUfZ","list":"Cards_list__2-F6W"};